<template>
  <b-container fluid="true" class="bg-white sidebar fs-14 px-10 fw-600" style="padding-top:20px; max-width: 100px;">
      <router-link to="/company-lookup" style="padding: 10px 1px 10px; text-decoration: none; color: #A7A9AC" class="flex-col align-items-center company-router" :class='{navlink_active: isNav_active("company")}'>
        <img src="../../static/BS2/Icons/Sidebar/store.svg" :class="{'sidebar-active': isNav_active('company'), 'sidebar-inactive': !(isNav_active('company'))}" class="pb-2" style="width:30px;"/>
        <span class="fs-12" style="line-height: 15px;">Empresa</span>
      </router-link>
      <router-link v-if="this.hasViewerAccess('cpf')" to="/cpf-lookup" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC" class="flex-col align-items-center cpf-router" :class='{navlink_active: isNav_active("cpf")}'>
        <img src="../../static/BS2/Company_Data/socio_cpf.svg" :class="{'sidebar-active': isNav_active('cpf'), 'sidebar-inactive': !(isNav_active('cpf'))}" class="pb-2" style="width:30px;"/>
        <span class="fs-12" style="line-height: 15px;">Pessoa</span>
      </router-link>
      <router-link to="/economic-group" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC"  class="flex-col align-items-center" :class='{navlink_active: isNav_active("economic-group")}'>
        <b-icon icon="building" :class="{'sidebar-active': isNav_active('economic-group'), 'sidebar-inactive': !(isNav_active('economic-group'))}" class="pb-2 font-black" style="width: 30px; height:30px;"></b-icon>
        <span class="fs-12" style="line-height: 15px;">Grupo Econômico</span>
      </router-link>
      <!-- <router-link v-if="currentCompany && currentCompany.permissions" to="/portfolio-lookup" style="padding: 10px 10px 30px; text-decoration: none; color: #A7A9AC" class="flex-col align-items-center" :class='{navlink_active: isNav_active("portfolio")}'>
        <img src="../../../static/BS2/Icons/Sidebar/person.svg" :class="{'sidebar-active': isNav_active('portfolio'), 'sidebar-inactive': !(isNav_active('portfolio'))}" class="pb-2" style="width:30px;"/>
        <span class="fs-12" style="line-height: 15px;">Portfolio em 1-click</span>
      </router-link> -->
      <!-- <router-link to="/nfe-lookup" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC"  class="flex-col align-items-center" :class='{navlink_active: isNav_active("nfe-lookup")}'>
        <img src="../../static/BS2/Icons/Sidebar/nfe_new.svg" :class="{'sidebar-active': isNav_active('nfe-lookup'), 'sidebar-inactive': !(isNav_active('nfe-lookup'))}" class="pb-2" style="width:30px;"/>
        <span class="fs-12" style="line-height: 15px;">NF-e</span>
      </router-link> -->

      <hr>

      <router-link v-if="isListsPageActive" to="/lists" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC"  class="flex-col align-items-center" :class='{navlink_active: isNav_active("lists-page")}'>
        <img src="../../static/BS2/Icons/Sidebar/list_new.svg" :class="{'sidebar-active': isNav_active('lists-page'), 'sidebar-inactive': !(isNav_active('lists-page'))}" class="pb-2" style="width:30px;"/>
        <span class="fs-12" style="line-height: 15px;">Listas</span>
      </router-link>
      <router-link v-if="isHistoryActive" to="/history" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC"  class="flex-col align-items-center" :class='{navlink_active: isNav_active("lookup-logs")}'>
        <img src="../../static/BS2/Icons/Sidebar/history_new.svg" :class="{'sidebar-active': isNav_active('lookup-logs'), 'sidebar-inactive': !(isNav_active('lookup-logs'))}" class="pb-2" style="width:30px;"/>
        <span class="fs-12" style="line-height: 15px;">Histórico</span>
      </router-link>

      <hr>

      <router-link v-if="hasAmlPermission" to="/compliance" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC"  class="flex-col align-items-center" :class='{navlink_active: isNav_active("tools")}'>
        <img src="../../static/BS2/Icons/compliance-icon.png" :class="isNav_active('tools') ? 'sidebar-active' : 'sidebar-inactive'" class="pb-2" style="width:32px;"/>
        <span class="fs-12" style="line-height: 15px;">Compliance</span>
      </router-link>


    <router-link v-if="hasAmlPermission" to="/rsac" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC"  class="flex-col align-items-center" :class='{navlink_active: isNav_active("rsac")}'>
      <img src="../../static/BS2/Icons/Sidebar/agreement.png" :class="isNav_active('rsac') ? 'sidebar-active' : 'sidebar-inactive'" class="pb-2" style="width:38px;"/>
      <span class="fs-12" style="line-height: 15px;">RSAC</span>
    </router-link>
      <router-link v-if="isFeatureActive('baas') || hasAmlPermission" to="/pld" style="padding: 10px 10px 10px; text-decoration: none; color: #A7A9AC"  class="flex-col align-items-center" :class='{navlink_active: isNav_active("pld")}'>
        <img src="../../static/BS2/Icons/Sidebar/handcuffs.png" :class="{'sidebar-active': isNav_active('pld'), 'sidebar-inactive': !(isNav_active('pld'))}" class="pb-2" style="width:30px;"/>
        <span class="fs-12" style="line-height: 15px;">PLD</span>
      </router-link>
  </b-container>
</template>

<script>
import { mapState } from 'pinia'
import { useAuthStore } from '@/stores/auth'

export default {
  name: "Sidebar",
  data() {
    return{
      nav_active: '',
      user_name: 'My Name',
      isHistoryActive:false,
      isListsPageActive: false
    }
  },
   computed:
   {
     ...mapState(useAuthStore, ['isFeatureActive']),
     hasAmlPermission(){
       return this.hasViewerAccess('aml')
     }
   },
  mounted() {
    this.setNav_active()
    this.isHistoryActive = true
    this.isListsPageActive = true
  },
  methods:{
    setNav_active(){
      let active = 'company'
      if(window.location.href.includes('company-lookup') || window.location.href.includes('/cnpj/') ){
        active = 'company'
      }
      // else if(window.location.href.includes('nfe-lookup')){
      //   active = 'nfe-lookup'
      // }
      else if(window.location.href.includes('portfolio')){
        active = 'portfolio'
      }
      else if(window.location.href.includes('history')){
        active = 'lookup-logs'
      }
      else if(window.location.href.includes('lists') || window.location.href.includes('list')){
        active = 'lists-page'
      }
      else if(window.location.href.includes('cpf_nome')){
        active = null
      }
      else if(window.location.href.includes('cpf')){
        active = 'cpf'
      }
      else if(window.location.href.includes('compliance') || window.location.href.includes('susep_docs')){
        active = 'tools'
      }
      else if(window.location.href.includes('compliance') || window.location.href.includes('rsac')){
        active = 'rsac'
      }
      else if(window.location.href.includes('economic-group')){
        active = 'economic-group'
      }
      else if(window.location.href.includes('baas')){
        active = 'baas'
      }
      else if(window.location.href.includes('pld')){
        active = 'pld'
      }
      else{
        active = null
      }
      this.nav_active = active
    },

    isNav_active(link){
      return link === this.nav_active
    },
  }
}
</script>
<style>
  .navlink_active{
    color: #2D2D2D !important;
    font-weight: 600;
  }
  .cpf-router .sidebar-active{
    filter: invert(53%) sepia(46%) saturate(4954%) hue-rotate(201deg) brightness(100%) contrast(103%);
  }
  .company-router .sidebar-active{
    filter: invert(60%) sepia(20%) saturate(5066%) hue-rotate(18deg) brightness(116%) contrast(116%);
  }
  .sidebar-active{
    filter: invert(94%) sepia(66%) saturate(576%) hue-rotate(96deg) brightness(88%) contrast(84%);
  }
  .sidebar-inactive{
    filter: invert(72%) sepia(0%) saturate(6095%) hue-rotate(164deg) brightness(104%) contrast(49%);
  }
  .link-active{
    color: #69D0CB !important;
  }
</style>
<style scoped>
  #app{
  }
  .hamburger-btn{
    display:none;
  }
  .nonmobile{
    display: flex !important;
  }
  .menu-container{
      flex-direction: column;
  }

  .sidebar-circle{
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: #e5e5e5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px 20px 0;
}
  @media only screen and (max-width: 730px){
  .sidebar{
    display:none !important;
  }
}
  @media only screen and (max-width: 767px){
    .hamburger-btn{
      display:inline-block;
    }
    .nonmobile{
      display: none !important;
    }
    .menu-container{
      flex-direction: row;
      align-items: center !important;
      margin: 24px 0 0 !important;
    }
    .full-container{
      margin: 0 24px !important;
    }
    .top-menu{
      margin: 0 !important;
    }
  }
  @media only screen and (max-width: 1106px){
    .insights-icon{
      display:none !important;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 900px){
    .full-container{
      /*margin: 0 50px 0 20px !important;*/
    }
  }
  .user-circle
  {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: #e5e5e5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
  }
  .logo-link:hover{
    text-decoration: none !important;
  }
</style>
